/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import classnames from 'classnames';
import CircularProgress from 'components/CircularProgress';
import ButtonWithSpinner from 'components/common/ButtonWithSpinner';
import EmptyData from 'components/common/EmptyData';
import IconComponent from 'components/common/IconComponent';
import SearchBarSuggestion from 'components/common/SearchBarSuggestion';
import React, { useMemo } from 'react';
import { SearchScopeEnum } from 'redux/search/types';

import { IRightColumn } from '../../types';

const RightColumn: React.FC<IRightColumn> = ({
  dataMapper,
  data,
  onClick,
  isMobile,
  hidden,
  onTitleButtonClick,
  onSearch,
  onScroll,
  loading,
}) => {
  const hideColumnClass = classnames('p-4 h-full overflow-y-auto transition-all duration-150 right-column-form', {
    'w-1/3': !isMobile,
    'w-full': isMobile,
    'translate-x-full absolute': isMobile && hidden,
    // '-translate-x-full': isMobile && hidden,
  });

  const RightColumnComponent = useMemo(
    () =>
      data?.map((d) => {
        const { component, className: dataRowClassName, disableRow } = dataMapper?.(d) || {};
        return (
          <div
            className={`flex border-b border-l border-r first:border-t border-border_color right-column-row ${
              dataRowClassName || ''
            }`}
            key={d.id}>
            <div className='flex flex-1 p-2 items-center'>
              <div className='line-clamp-1'>{component}</div>
            </div>
            <div className='flex items-center p-2'>
              <ButtonWithSpinner
                height='auto'
                width='30px'
                color='#038fde'
                buttonType='text'
                onClick={() => {
                  if (!disableRow) onClick?.(d);
                  // onTitleButtonClick?.();
                }}>
                <span className='text-xl'>+</span>
              </ButtonWithSpinner>
            </div>
          </div>
        );
      }),
    [data, onClick],
  );
  return (
    <div onScroll={onScroll} className={hideColumnClass}>
      {isMobile && (
        <ButtonWithSpinner
          buttonType='text'
          onClick={onTitleButtonClick}
          style={{ padding: 0, width: 'auto', paddingRight: 20 }}>
          <IconComponent name='chevron-left' size={20} />
        </ButtonWithSpinner>
      )}
      {onSearch && (
        <div className='mb-4'>
          <SearchBarSuggestion onSearch={onSearch} entities={[SearchScopeEnum.USER]} />
        </div>
      )}
      <div>
        {RightColumnComponent}
        {loading && <CircularProgress />}
        {!data?.length && !loading && <EmptyData />}
      </div>
    </div>
  );
};
export default React.memo(RightColumn);
